import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { initializeI18n } from './i18n/i18n';
import { installAxiosApiUrlGuard } from './lib/axios-api-url-guard';
import './styles/globals.css';

// Initialize i18n before rendering
initializeI18n('en');
installAxiosApiUrlGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
